import React from 'react';
import { View } from 'react-native';

import Text from '../../components/text/Text';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { createMachineDirectionsViewStyles } from './MachineDirectionsView.styles';

// A read-only value with its label; empty values show the placeholder in a quieter colour.
const DirectionsField = ({ label, value, placeholder }) => {
	const styles = useThemedStyles(createMachineDirectionsViewStyles);
	const hasValue = typeof value === 'string' ? Boolean(value.trim()) : Boolean(value);

	return (
		<View style={styles.field}>
			<Text style={styles.fieldLabel}>{label}</Text>
			<Text selectable={true} style={[styles.fieldValue, !hasValue && styles.fieldEmpty]}>{hasValue ? value : placeholder}</Text>
		</View>
	);
};

export default DirectionsField;
